import Vue from 'vue'
import VDeleteDialog from '@/components/VDeleteDialog'
import VChangePasswordDialog from '@/components/VChangePasswordDialog.vue';

export const eventBus = new Vue();
export default {
	install: (Vue, options) => {
		Vue.prototype.$eventBus = eventBus;
		Vue.component('VDeleteDialog', VDeleteDialog);
		Vue.component('VChangePasswordDialog', VChangePasswordDialog);
	}
}